export default __webpack_public_path__ + "static/media/30-red.aa171e86.png";